import { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);

const sameVariant = (i, product_id, size, color) =>
  i.product_id === product_id && (i.size || null) === (size || null) && (i.color || null) === (color || null);

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem("cart")) || []; } catch { return []; }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem("cart", JSON.stringify(items));
  }, [items]);

  const addItem = (product, size, color, quantity = 1) => {
    setItems((prev) => {
      const idx = prev.findIndex((i) => sameVariant(i, product.id, size, color));
      if (idx >= 0) {
        const copy = [...prev];
        copy[idx] = { ...copy[idx], quantity: copy[idx].quantity + quantity };
        return copy;
      }
      return [...prev, { product_id: product.id, name: product.name, price: product.price,
        image: product.image, size, color, quantity }];
    });
    setOpen(true);
  };

  const updateQty = (product_id, size, color, quantity) => {
    setItems((prev) => prev.map((i) =>
      sameVariant(i, product_id, size, color) ? { ...i, quantity: Math.max(1, quantity) } : i));
  };

  const removeItem = (product_id, size, color) => {
    setItems((prev) => prev.filter((i) => !sameVariant(i, product_id, size, color)));
  };

  const clear = () => setItems([]);

  const count = items.reduce((s, i) => s + i.quantity, 0);
  const total = items.reduce((s, i) => s + i.price * i.quantity, 0);

  return (
    <CartContext.Provider value={{ items, addItem, updateQty, removeItem, clear, count, total, open, setOpen }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
